import * as actionTypes from 'modules/appointments/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const setIds = (_, { payload }) => [...payload.content.map(({ id }) => id)];
const removeOne = (state, { payload: appointmentId }) => state.filter(id => id !== appointmentId);

export default createReducer(initialState, {
  [actionTypes.DELETE_SUCCESS]: removeOne,
  [actionTypes.FETCH_APPOINTMENTS_SUCCESS]: setIds,
});
